import React from 'react';

import MuiProgressLinear, {
  LinearProgressProps as MuiProgressLinearProps,
} from '@mui/material/LinearProgress';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const ProgressLinear = withCoreProps<ProgressLinearProps>(
  ({ className, ...props }: React.PropsWithChildren<ProgressLinearProps>) => {
    const clsxClass = clsx(className);

    return <MuiProgressLinear {...props} className={clsxClass} />;
  },
);

export interface ProgressLinearProps
  extends MuiProgressLinearProps,
    CoreProps {}
